import { render, staticRenderFns } from "./m-block-table-hint.vue?vue&type=template&id=05e8f822&scoped=true&lang=pug&"
import script from "./m-block-table-hint.vue?vue&type=script&lang=js&"
export * from "./m-block-table-hint.vue?vue&type=script&lang=js&"
import style0 from "./m-block-table-hint.vue?vue&type=style&index=0&id=05e8f822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e8f822",
  null
  
)

export default component.exports